import React from "react";
import { Platform, StyleSheet, View } from "react-native";
import Text from "./text";
import translate from "../libs/locale";
import { CheckBox } from "@rneui/base";
import variables from "../assets/variables";
import { PaymentMethodProps } from "../types/paymentMethods";

const PaymentMethod = (props: PaymentMethodProps) => {
  const { containerStyle, type, paymentMethods, onPress } = props;

  const getCheckedIcon = () => {
    if (Platform.OS === "web") {
      return (
        <View style={[styles.checked, styles.baseCheck]}>
          <View style={styles.innerChecked} />
        </View>
      );
    }
    return "dot-circle-o";
  };

  const getUnCheckedIcon = () => {
    if (Platform.OS === "web") {
      return <View style={[styles.unChecked, styles.baseCheck]} />;
    }
    return "circle-o";
  };

  if (!paymentMethods?.length) {
    return null;
  }

  return (
    <>
      <View style={[containerStyle]}>
        <View style={styles.header}>
          <Text style={styles.headerName}>{translate("paymentMethod")}</Text>
        </View>
        {paymentMethods?.map((it) => {
          return (
            <CheckBox
              key={it.id.toString()}
              checked={type === it.id}
              onPress={() => onPress(it.id)}
              checkedIcon={getCheckedIcon()}
              uncheckedIcon={getUnCheckedIcon()}
              title={it.name}
              checkedColor={variables.$brandColor}
              containerStyle={styles.checkbox}
              titleProps={{
                style: [
                  styles.text,
                  {
                    color:
                      type === it.id ? variables.$brandColor : variables.$black,
                    fontFamily:
                      type === it.id ? "MontserratBold" : "Montserrat",
                  },
                ],
              }}
            />
          );
        })}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  header: {
    borderBottomColor: "#F4F4F4",
    borderBottomWidth: 1,
    marginTop: 0,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 8,
  },
  headerName: {
    color: "#636E72",
    fontSize: 14,
    fontFamily: "MontserratBold",
  },
  checked: {},
  unChecked: {},
  baseCheck: {
    height: 24,
    width: 24,
    borderRadius: 24,
    marginRight: 12,
    borderColor: variables.$brandColor,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  innerChecked: {
    height: 14,
    width: 14,
    borderRadius: 8,
    backgroundColor: variables.$brandColor,
  },
  checkbox: {
    marginLeft: 0,
    paddingLeft: 0,
  },
  text: {
    fontFamily: "Montserrat",
    fontSize: 14,
  },
});

export default PaymentMethod;
